import React, {FC} from 'react'

import cn from 'classnames/bind'
import Link from 'next/link'

import Button from 'components/elements/Button'
import CardLabel from 'components/elements/CardLabel'
import IconCheck from 'src/assets/icons/check.svg'
import Price from 'src/components/elements/Price'
import {TPriceColor} from 'src/types'
import {posthogTrack} from 'src/utils'

import s from './PricingCard.module.scss'
import PricingCardWrapper from '../PricingCardWrapper'
const cx = cn.bind(s)

interface IPricingCardProps {
	color: TPriceColor
	title: string
	currency: string
	price: number
	slug: string
	priceTitle: string
	label?: string
	benefits?: string[]
	href: string
	className?: string
}

const PricingCard: FC<IPricingCardProps> = ({
	color,
	title,
	currency,
	slug,
	price,
	priceTitle,
	label,
	benefits,
	href,
	className,
}) => {
	return (
		<PricingCardWrapper title={title} color={color} className={cx(className)}>
			<div className={cx('card-body')}>
				<div className={cx('pricing-wrapper')}>
					<Price currency={currency} price={price} priceTitle={priceTitle} />
					{label && (
						<CardLabel
							label={label}
							className={cx('label', {'label-benefits': benefits && benefits.length > 0})}
						/>
					)}
				</div>
				{benefits && benefits.length > 0 && (
					<div className={cx('benefits-wrapper')}>
						<ul className={cx('benefits')}>
							{benefits.map((item, index) => (
								<li key={index} className={cx('benefits__item')}>
									<IconCheck className={cx('benefit__icon')} />
									<span className={cx('benefit__text')}>{item}</span>
								</li>
							))}
						</ul>
					</div>
				)}
				<div className={cx('wrapper-btn')}>
					<Link passHref href={href} legacyBehavior>
						<Button
							variant="primary"
							size="big"
							as="a"
							onClick={() => {
								posthogTrack('[PRICING] Get now button on the pricing card clicked', {
									plan: slug,
								})
							}}
							data-testid={`btn-get-${slug}`}>
							Get now!
						</Button>
					</Link>
				</div>
			</div>
		</PricingCardWrapper>
	)
}

PricingCard.displayName = 'PricingCard'

export default PricingCard
